export const SET_TOKEN = 'setToken';
export const SAVE_SEARCH = 'saveSearch';
export const SET_PERMISOS = 'setPermisos';
